mutation TravelAuthorizationApprovalCreate(
  $input: TravelAuthorizationApprovalCreateInput!
) {
  travelAuthorizationApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
